export const appName = () => {
	return 'YouEvent365 Organizer';
	// return this.$t('app.name' /* YouEvent365® Attendee */);
};

export const apiServer = () => {
	const url = window.location.href;
	console.log(`connect, docment.url=${url}`);
	// eslint-disable-next-line no-undef
	console.log(`connect, YSS_ENV=${YSS_ENV}`);
	// eslint-disable-next-line no-undef
	console.log(
		`connect, YSS_PRODUCTION_API_SERVER=${YSS_PRODUCTION_API_SERVER}`
	);
	// eslint-disable-next-line no-undef
	console.log(
		`connect, YSS_DEVELOPMENT_API_SERVER=${YSS_DEVELOPMENT_API_SERVER}`
	);

	// eslint-disable-next-line no-undef
	return YSS_ENV === 'production'
		? // eslint-disable-next-line no-undef
		  YSS_PRODUCTION_API_SERVER
		: // eslint-disable-next-line no-undef
		  YSS_DEVELOPMENT_API_SERVER;

	/*
	return url.indexOf('rd3.') >= 0 ||
		url.indexOf('ta3.') >= 0 ||
		url.indexOf('tc3.') >= 0 ||
		url.indexOf('localhost') >= 0 ||
		url.indexOf('127.0.0') >= 0
		? 'https://rd1.YouEvent365.app'
		: 'https://www1.YouEvent365.app';
	*/

	/*	
	return url.indexOf('rd5.') >= 0 ||
		url.indexOf('ta5.') >= 0 ||
		url.indexOf('tc5.') >= 0 ||
		url.indexOf('localhost') >= 0 ||
		url.indexOf('127.0.0') >= 0
		? 'https://rd1.YouEvent365.app'
		: 'https://www1.YouEvent365.app';
	*/

	// process.env.NODE_ENV === 'production' ? 'https://www5.youevent365.app' : 'https://rd5.youevent365.app';
};

export const webServer = () => {
	const url = window.location.href;
	console.log(`connect, webServer url=${url}`);

	// eslint-disable-next-line no-undef
	return YSS_ENV === 'production'
		? // eslint-disable-next-line no-undef
		  YSS_PRODUCTION_WEBSITE
		: // eslint-disable-next-line no-undef
		  YSS_DEVELOPMENT_WEBSITE;
};
